import React from "react";

interface TituloProps {
  text: string;
}

export function Titulo(props: TituloProps) {
  return <h2 style={{ marginBottom: "1em" }}>{props.text}</h2>;
}
